export default function SearchIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" {...props}>
			<path d="m39.25 40.3-12.8-12.8q-1.5 1.35-3.475 2.05-1.975.7-3.975.7-4.75 0-8.075-3.3Q7.6 23.65 7.6 18.9q0-4.75 3.3-8.05 3.3-3.3 8.05-3.3 4.75 0 8.075 3.3 3.325 3.3 3.325 8.05 0 2.05-.725 4.025Q28.9 24.9 27.55 26.4L40.4 39.15ZM19 28.7q4.15 0 7-2.825 2.85-2.825 2.85-6.975 0-4.15-2.85-7-2.85-2.85-7-2.85t-7 2.85q-2.85 2.85-2.85 7T12 25.875q2.85 2.825 7 2.825Z" />
		</svg>
	)
}
